module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dom/node_modules/prop-types/lib/has.js
// module id = 644
// module chunks = 1